<template>
  <div class="foods">
    <main-app-bar>
      <template v-slot:title> Food Database </template>

      <template v-slot:actions>
        <div class="app-bar--bottom-actions nav-pills">
          <v-btn :to="{ name: 'active.foods' }" depressed replace>
            Active
          </v-btn>
          <v-btn :to="{ name: 'deleted.foods' }" depressed replace>
            Deleted
          </v-btn>
          <v-btn :to="{ name: 'import.foods' }" depressed>
            Import Food Journal
          </v-btn>
        </div>

        <v-btn
          class="bg-primary-gradient primary ml-auto"
          @click="$router.push({ name: 'form.food' })"
          depressed
        >
          <v-icon class="mr-2"> {{ icons.add }} </v-icon>
          Add New Food Entries
        </v-btn>
      </template>
    </main-app-bar>

    <div class="mt-5 px-12 mb-10">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import MainAppBar from '@/layouts/shared/MainAppBar'
import { mdiPlus } from '@mdi/js'

export default {
  name: 'FoodPage',

  components: {
    MainAppBar,
  },

  data() {
    return {
      addNew: false,
      icons: {
        add: mdiPlus,
      },
    }
  },
}
</script>
